// Module
var code = "<core-header></core-header> <div class=\"container\" style=\"margin-top:-1px\"> <div ui-view></div> </div> ";
// Exports
export default code;